import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'afra-tab-item',
  imports: [],
  templateUrl: './tab-item.component.html',
  styleUrl: './tab-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AfraTabItemComponent {
  @Input() title!: string;

  @ViewChild('tpl', { static: true })
  template!: TemplateRef<any>;
}
